import React from 'react';

export const CheckInCircleIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g>
            <path
                d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
                stroke="currentColor"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.334 6.157a.75.75 0 01.115 1.024l-7.317 9.64a1.728 1.728 0 01-.395.386l-.003.002c-.767.535-1.806.324-2.324-.471l-2.282-3.374a.748.748 0 01.169-1.015.682.682 0 01.975.176l2.287 3.379.01.014a.273.273 0 00.454.014l.008-.01 7.32-9.645c.24-.316.68-.37.983-.12z"
            fill="currentColor"
        />
    </svg>
);
